import React, { lazy } from "react";
import { Routes, Route, Navigate } from "react-router";
import CssBaseline from "@mui/material/CssBaseline";

import "./App.css";

// Layout & Theme
import ThemeCustomization from "./themes";
import ScrollTop from "./container/ScrollTop";
import Layout from "./container/Layout/Layout";

// Routing Guards
import PublicRoutes from "./container/Layout/PublicRoutes";
import AuthLayout from "./container/Layout/AuthLayout";

// Public Pages
import Login from "./container/Login";
import External from "./container/External";

// Internal Pages
import Internal from "./container/Internal/Internal";
import { CreateCampus } from "./container/Internal/Campuses/CampusDetail/CreateCampus";
import { DroneNest } from "./container/Internal/Campuses/CampusDetail/DroneNest";
import {
  CampusDetail,
  Campuses,
  ViewCampus,
} from "./container/Internal/Campuses";
import {
  FirmwareContainer,
  FirmwareFormContainer,
  ReleaseContainer,
  AppReleaseContainer,
  AppReleaseFormContainer,
} from "./container/Internal/release";

// Lazy Loaded Pages
const Users = lazy(() => import("./container/Internal/Users/Users"));
const Policies = lazy(() => import("./container/Internal/Policies/Policies"));

const App = () => {
  console.info(process.env.REACT_APP_VERSION);

  return (
    <ThemeCustomization>
      <ScrollTop>
        <CssBaseline enableColorScheme />
        <Layout>
          <Routes>
            {/* Public Routes */}
            <Route
              element={
                <PublicRoutes>
                  <External />
                </PublicRoutes>
              }
            >
              <Route path="login" element={<Login />} />
            </Route>

            {/* Protected Routes */}
            <Route path="/" element={<AuthLayout />}>
              <Route element={<Internal />}>
                <Route path="policies" element={<Policies />} />
                <Route path="release" element={<ReleaseContainer />}>
                  <Route index element={<Navigate to="firmware" replace />} />
                  <Route path="firmware">
                    <Route index element={<FirmwareContainer />} />
                    <Route path="add" element={<FirmwareFormContainer />} />
                  </Route>
                  <Route path="pilotApp">
                    <Route index element={<AppReleaseContainer />} />
                    <Route path="add" element={<AppReleaseFormContainer />} />
                  </Route>
                </Route>
                <Route path="user" element={<Users />} />
                <Route path="campuses">
                  <Route index element={<Campuses />} />
                  <Route element={<CampusDetail />}>
                    <Route path=":campusId">
                      <Route index element={<ViewCampus />} />
                      <Route path="edit" element={<CreateCampus />} />
                      <Route path="droneNest" element={<DroneNest />} />
                    </Route>
                    <Route path="add" element={<CreateCampus />} />
                  </Route>
                </Route>
              </Route>
            </Route>

            {/* Fallback Route */}
            <Route path="*" element={<div>Page Not Found</div>} />
          </Routes>
        </Layout>
      </ScrollTop>
    </ThemeCustomization>
  );
};

export default App;
